var map = {
	"./Childrenarea_6.jpg": 7932,
	"./E_block_8.jpg": 2115,
	"./Gateview_1.jpg": 9675,
	"./H_block_7.jpg": 9465,
	"./Jblock_10.jpg": 7514,
	"./Layout_11.jpg": 8538,
	"./Premangan_9.jpg": 7152,
	"./Shivangan_3.jpg": 5170,
	"./Swimmingpool_5.jpg": 9960,
	"./Templeview_2.jpg": 2098,
	"./Tulsiangan_4.jpg": 9044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5373;